import { render, staticRenderFns } from "./TopupWithdrawHistory.vue?vue&type=template&id=905f59c4&"
import script from "./TopupWithdrawHistory.vue?vue&type=script&lang=js&"
export * from "./TopupWithdrawHistory.vue?vue&type=script&lang=js&"
import style0 from "./TopupWithdrawHistory.vue?vue&type=style&index=0&id=905f59c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports